import type { AmplienceMeta } from '~/types/amplience';

export const getAmplienceMeta = (
  meta?: AmplienceMeta
): {
  metaAttributes: {
    'data-content-id'?: string;
    'data-content-name'?: string;
    'data-content-key'?: string;
  };
  contentId?: string;
  contentName?: string;
  contentKey?: string;
  schema?: string;
} => {
  const contentId = meta?.deliveryId;
  const contentName = meta?.name;
  const contentKey = meta?.deliveryKey;
  const schema = meta?.schema;

  return {
    contentId,
    contentName,
    contentKey,
    schema,
    metaAttributes: {
      'data-content-id': contentId,
      'data-content-name': contentName,
      ...(contentKey ? { 'data-content-key': contentKey } : {}),
    },
  };
};
